import { ConsultationBand, PublicHero, PublicShell } from "@/components/PublicShell"
import { PublicMeta } from "@/components/public/PublicMeta"

const DESCRIPTION =
  "How SOH GD Wines collects, uses and protects the personal information you share with us when you enquire or download from this site."

export default function Privacy() {
  return (
    <PublicShell>
      <PublicMeta title="Privacy Policy" description={DESCRIPTION} />
      <PublicHero
        eyebrow="Legal"
        title="Privacy Policy"
        lede="How we collect, use and protect the personal information you share with us."
      />

      <section className="band band-black">
        <div className="shell">
          <div className="body-content max-w-[70ch]">
            <p>
              <strong>Draft for Duncan's review.</strong> This page is a standard template for a
              UK bespoke-label wine supplier and has not yet been signed off. It must be reviewed
              and approved before the site goes live.
            </p>

            <p>Last updated: 25 September 2026.</p>

            <h2>Who we are</h2>
            <p>
              SOH GD Wines ("we", "us", "our") supplies bespoke-label South African wine to
              customers in the United Kingdom. This policy explains what personal information we
              collect through this website, why we collect it, and what rights you have over it,
              in line with the UK General Data Protection Regulation (UK GDPR) and the Data
              Protection Act 2018.
            </p>

            <h2>What we collect</h2>
            <ul>
              <li>
                <strong>Enquiry and order details</strong> — name, company (if given), phone
                number, email address, event type and date, your message, and any artwork you
                upload, when you submit our contact or consultation form.
              </li>
              <li>
                <strong>Account details</strong> — name and email address, if you create an
                account to track an order or a saved design.
              </li>
              <li>
                <strong>Marketing preferences</strong> — whether you have consented to receive
                follow-up communications from us.
              </li>
              <li>
                <strong>Technical information</strong> — standard web server logs (such as IP
                address and browser type) collected automatically when you visit the site.
              </li>
            </ul>

            <h2>How we use it</h2>
            <ul>
              <li>To respond to your enquiry and provide a quote.</li>
              <li>To produce and approve a bespoke label design with you.</li>
              <li>To process and fulfil an order you place with us by enquiry (we do not take payment online).</li>
              <li>To send you order and design updates, and — only with your consent — occasional follow-up messages.</li>
              <li>To keep our records accurate and meet our legal and accounting obligations.</li>
            </ul>

            <h2>How we store it</h2>
            <p>
              Your information is stored securely on our systems and, where relevant, with the
              service providers who help us run this site (such as our email delivery and cloud
              storage providers). We keep enquiry and order records for as long as reasonably
              needed for accounting and customer service purposes, and no longer than necessary.
            </p>

            <h2>Sharing your information</h2>
            <p>
              We do not sell your personal information. We share it only with the service
              providers who help us operate — for example, to send transactional emails or store
              uploaded artwork — and only to the extent needed for them to provide that service.
            </p>

            <h2>Your rights</h2>
            <p>
              Under UK GDPR you have the right to access, correct, or ask us to delete your
              personal information, to object to or restrict certain processing, and to withdraw
              marketing consent at any time. To exercise any of these rights, contact us using the
              details on our <a href="/contact">Contact</a> page.
            </p>
            <p>
              If you are unhappy with how we have handled your information, you also have the
              right to complain to the UK's supervisory authority, the{" "}
              <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">
                Information Commissioner's Office (ICO)
              </a>
              .
            </p>

            <h2>Cookies</h2>
            <p>
              This site uses only the technical cookies needed to keep it working correctly (for
              example, to remember whether you prefer light or dark mode). We do not use tracking
              or advertising cookies.
            </p>

            <h2>Age</h2>
            <p>
              Our products contain alcohol and are intended for adults. By enquiring or ordering
              through this site you confirm that you are 18 or over.
            </p>

            <h2>Changes to this policy</h2>
            <p>
              We may update this policy from time to time. Any changes will be posted on this
              page with an updated revision date.
            </p>

            <h2>Contact us</h2>
            <p>
              Questions about this policy, or about your personal information, can be sent through
              our <a href="/contact">Contact</a> page.
            </p>
          </div>
        </div>
      </section>

      <ConsultationBand />
    </PublicShell>
  )
}
